import clsx from 'clsx';
import Link from 'next/link';

export const getCollectionByGeneration = (generation) => {
  if (generation === 1) {
    return 'firstLitter';
  }
  if (generation === 2) {
    return 'secondLitter';
  }
  if (generation === 3) {
    return 'thirdLitter';
  }
  if (generation === 4) {
    return 'fourthLitter';
  }
  return 'firstLitter';
};

const getCollectionPath = (collection) => {
  if (collection === 'fourthLitter') {
    return 'fourth-litter';
  }
  if (collection === 'thirdLitter') {
    return 'third-litter';
  }
  if (collection === 'secondLitter') {
    return 'second-litter';
  }
  if (collection === 'firstLitter') {
    return 'first-litter';
  }
  return collection;
};

const getFurLayer = (trait, collection) => {
  let furLayer = 'behind';
  if (trait === 'Accessory' && collection === 'secondLitter') {
    furLayer = 'front';
  }
  if (trait === 'Background') {
    furLayer = 'front';
  }
  if (trait === 'Fur') {
    furLayer = '';
  }
  return furLayer;
};

const getDirectoryPath = (traitType) => {
  if (traitType === 'Background') {
    return 'backgrounds';
  } else if (traitType === 'Eyes') {
    return 'eyes';
  } else if (traitType === 'Mouth') {
    return 'mouthes';
  } else if (traitType === 'Clothing') {
    return 'clothing';
  } else if (traitType === 'Head') {
    return 'heads';
  } else if (traitType === 'Whiskers') {
    return 'whiskers';
  } else if (traitType === 'Accessory') {
    return 'accessories';
  } else if (traitType === 'Special') {
    return 'special';
  } else if (traitType === 'Clothes') {
    return 'clothes';
  }
  return `${traitType.toLowerCase()}s`;
};

const getCollectionPathForUrl = (collection) => {
  if (collection === 'fourthLitter') {
    return 'shitty-kitties-fourth-litter';
  } else if (collection === 'thirdLitter') {
    return 'shitty-kitties-third-litter';
  } else if (collection === 'secondLitter') {
    return 'shitty-kitties-slt';
  } else if (collection === 'firstLitter') {
    return 'shitty-kitties';
  }
  return collection;
};

function TraitImage({ collection, trait, value, owned }) {
  const furLayer = getFurLayer(trait, collection);
  const collectionForUrl = getCollectionPathForUrl(collection);
  const href = `https://market.downbad.farm/collection/${collectionForUrl}`;

  return (
    <Link href={href}>
      <a className='block' title={value}>
        <div className={clsx('relative w-full aspect-square inset-0', !owned && 'opacity-25 grayscale')}>
          {furLayer === 'behind' && (
            <img
              src={`/${getCollectionPath(collection)}/traits/furs/${collection === 'firstLitter' ? 'Gray Tiger' : 'Normal'}.png`}
              alt={'kitty fur'}
              className={clsx('rounded-md absolute top-0 left-0 w-full h-full z-10 grayscale')}
            />
          )}
          <img
            src={`/${getCollectionPath(collection)}/traits/${getDirectoryPath(trait)}/${value.replace('#', '')}.png`}
            alt={value}
            className={clsx('rounded-md absolute top-0 left-0 w-full h-full z-20')}
          />
          {furLayer === 'front' && (
            <img
              src={`/${getCollectionPath(collection)}/traits/furs/${collection === 'firstLitter' ? 'Gray Tiger' : 'Normal'}.png`}
              alt={'kitty fur'}
              className={clsx('rounded-md absolute top-0 left-0 w-full h-full z-30 grayscale')}
            />
          )}
        </div>
      </a>
    </Link>
  );
}

export default TraitImage;
